import { useState } from 'react'

import { StoreBonusStatusResponse } from '@common/models/bonus'
import cx from 'classnames'

import { STORE_BG } from '@/features/storefronts/_storeBase/constants'

import { BonusMissions } from './bonusMissions/BonusMissions'
import { BonusOverlayHeader } from './BonusOverlayHeader'
import { BonusTrack } from './bonusTrack/BonusTrack'
import { useGameSlug } from '../../../game-provider'

import styles from './bonusOverlay.module.scss'

export type BonusView = 'bonuses' | 'missions'

interface BonusOverlayProps {
  bonusStatus: StoreBonusStatusResponse
  animationComplete?: boolean
}

export const BonusOverlay = ({ bonusStatus, animationComplete }: BonusOverlayProps) => {
  const gameSlug = useGameSlug()
  const [view, setView] = useState<BonusView>('bonuses')

  return (
    <div className={cx(styles.container, styles[gameSlug])}>
      {gameSlug === 'brawlstars' && (
        <div className={styles.rotatedBgContainer}>
          <div className={styles.rotatedBg} style={{ backgroundImage: STORE_BG(gameSlug) }} />
        </div>
      )}
      <div className={styles.header}>
        <BonusOverlayHeader onClick={setView} selectedView={view} />
      </div>

      {view === 'bonuses' && <BonusTrack bonusStatus={bonusStatus} animationComplete={animationComplete} />}
      {view === 'missions' && <BonusMissions bonusStatus={bonusStatus} />}
    </div>
  )
}
